exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1jwRe5yqxST68KJAwSM1n0{background:#fff;max-width:100%;display:flex;flex-wrap:wrap;align-items:center;padding:15px}._1jwRe5yqxST68KJAwSM1n0._15I1k6NvmZNeFz_jHPrRZ{justify-content:space-around}._2Jdy7SLaOoJ5iUk8mLdeLW{display:flex;align-items:center;height:44px;margin:5px 0px;flex-grow:1;flex-shrink:0;flex-basis:44px;justify-content:center;max-width:50px}\n", ""]);

// Exports
exports.locals = {
	"Organizations": "_1jwRe5yqxST68KJAwSM1n0",
	"collapsed": "_15I1k6NvmZNeFz_jHPrRZ",
	"organization": "_2Jdy7SLaOoJ5iUk8mLdeLW"
};